import { qualityColor, qualityLabelKey } from "./netquality";

// Índice 0-100 de estado del camino (nube: pdui_api/vibration/grid.py) y
// sus métricas. Las bandas copian la escala del mapa de red para que los
// colores signifiquen lo mismo en los dos mapas.
export const METRICS = {
  score: { unit: "", higherIsBetter: true, decimals: 0 },
  rms_v: { unit: "m/s²", higherIsBetter: false, decimals: 2 },
  rms_p95: { unit: "m/s²", higherIsBetter: false, decimals: 2 },
  rms_h: { unit: "m/s²", higherIsBetter: false, decimals: 2 },
  peak_g: { unit: "g", higherIsBetter: false, decimals: 1 },
  impacts: { unit: "", higherIsBetter: false, decimals: 0 },
  speed_kmh: { unit: "km/h", higherIsBetter: null, decimals: 0 },
};
export const METRIC_ORDER = ["score", "rms_v", "rms_p95", "peak_g", "impacts", "speed_kmh"];

const RMS_POINTS = [[0.3, 100], [0.6, 75], [1.0, 50], [1.6, 25], [2.5, 0]];

export function scoreFromRms(rms) {
  if (rms === null || rms === undefined) return null;
  const x = Number(rms);
  if (x <= RMS_POINTS[0][0]) return 100;
  if (x >= RMS_POINTS[RMS_POINTS.length - 1][0]) return 0;
  for (let i = 0; i < RMS_POINTS.length - 1; i += 1) {
    const [x0, s0] = RMS_POINTS[i];
    const [x1, s1] = RMS_POINTS[i + 1];
    if (x >= x0 && x <= x1) return s0 + ((s1 - s0) * (x - x0)) / (x1 - x0);
  }
  return 0;
}

// Calidad 0..4 (muy mala … excelente) de una métrica, para colorear.
export function metricQuality(metric, value) {
  if (value === null || value === undefined) return null;
  let score;
  if (metric === "score") score = Number(value);
  else if (metric === "rms_v" || metric === "rms_p95" || metric === "rms_h") score = scoreFromRms(value);
  else if (metric === "peak_g") score = Math.max(0, Math.min(100, 100 - (Number(value) - 1) * 40));
  else if (metric === "impacts") score = Math.max(0, 100 - Number(value) * 20);
  else return null;
  if (score >= 80) return 4;
  if (score >= 60) return 3;
  if (score >= 40) return 2;
  if (score >= 20) return 1;
  return 0;
}

export { qualityColor, qualityLabelKey };

export function formatMetric(metric, value) {
  if (value === null || value === undefined) return "—";
  const spec = METRICS[metric] || { decimals: 1, unit: "" };
  return `${Number(value).toFixed(spec.decimals)}${spec.unit ? ` ${spec.unit}` : ""}`;
}

export function legendStops(metric) {
  if (metric === "rms_v" || metric === "rms_p95" || metric === "rms_h") {
    return [[4, "≤ 0.5"], [3, "0.5–0.8"], [2, "0.8–1.3"], [1, "1.3–2.0"], [0, "> 2.0"]].map(([q, label]) => ({ q, color: qualityColor(q * 25), label: `${label} m/s²` }));
  }
  if (metric === "peak_g") {
    return [[4, "< 1.5"], [3, "1.5–2"], [2, "2–2.5"], [1, "2.5–3"], [0, "> 3"]].map(([q, label]) => ({ q, color: qualityColor(q * 25), label: `${label} g` }));
  }
  if (metric === "impacts") {
    return [[4, "0"], [3, "1"], [2, "2"], [1, "3"], [0, "4+"]].map(([q, label]) => ({ q, color: qualityColor(q * 25), label }));
  }
  if (metric === "speed_kmh") {
    return [];
  }
  return [[4, "80–100"], [3, "60–80"], [2, "40–60"], [1, "20–40"], [0, "0–20"]].map(([q, label]) => ({ q, color: qualityColor(q * 25), label }));
}
